import { useEffect } from 'react';

const BrevoConversations = () => {
  useEffect(() => {
    (function(d, w, c) {
      w.BrevoConversationsID = '66e5f709c530e1d44a03a711';
      w[c] = w[c] || function() {
        (w[c].q = w[c].q || []).push(arguments);
      };
      const s = d.createElement('script');
      s.async = true;
      s.src = 'https://conversations-widget.brevo.com/brevo-conversations.js';
      if (d.head) d.head.appendChild(s);
    })(document, window, 'BrevoConversations');
  }, []);

  return null; // Since the widget is external, no JSX is needed to render within this component.
};
export default BrevoConversations;

